import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CopyrightAlertService } from '../../../services/copyright-alert.service';

@Component({
  selector: 'app-copyright-alert',
  templateUrl: './copyright-alert.component.html',
  styleUrls: ['./copyright-alert.component.css']
})
export class CopyrightAlertComponent implements OnInit {
  
  constructor(
    public bsModalRef: BsModalRef,
    private copyrightAlertService: CopyrightAlertService
  ) { }

  ngOnInit(): void {
  }

  onAceitar(): void {
    // Marca que o usuário aceitou os termos
    this.copyrightAlertService.acceptCopyright();
    this.bsModalRef.hide();
  }
}
